// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiErrorResponse,
    ObjectIdResponse,
    ObjectNoResponse,
    ProviderClearinghouse,
    ProviderClearinghouseEra,
    ProviderClearinghouseEraItem,
    ProviderClearinghouseEraItemSortType,
    ProviderClearinghouseEraSortType,
    ProviderClearinghouseSortType,
    ProviderUpdateClearinghouseEraPayload,
    SupportClearinghouse,
    SupportClearinghouseEra,
    SupportClearinghouseEraItem,
    SupportClearinghouseEraItemSortType,
    SupportClearinghouseEraSortType,
    SupportClearinghouseSortType,
    SupportCreateClearinghousePayload,
    SupportCreateClearinghouseProviderEnrollmentPayload,
    SupportUpdateClearinghouseEraPayload,
    SupportUpdateClearinghousePayload,
    TemporaryUrl,
    ProviderUpdateClearinghouseEraPayloadToJSON,
    SupportCreateClearinghousePayloadToJSON,
    SupportCreateClearinghouseProviderEnrollmentPayloadToJSON,
    SupportUpdateClearinghouseEraPayloadToJSON,
    SupportUpdateClearinghousePayloadToJSON,
    ObjectIdResponseFromJSON,
    ObjectNoResponseFromJSON,
    ProviderClearinghouseFromJSON,
    ProviderClearinghouseEraFromJSON,
    ProviderClearinghouseEraItemFromJSON,
    SupportClearinghouseFromJSON,
    SupportClearinghouseEraFromJSON,
    SupportClearinghouseEraItemFromJSON,
    TemporaryUrlFromJSON,
} from '../models';

export interface CreateClearinghouseProviderEnrollmentRequest {
    id: string;
    supportCreateClearinghouseProviderEnrollmentPayload: SupportCreateClearinghouseProviderEnrollmentPayload;
}

export interface CreateSupportClearinghouseRequest {
    supportCreateClearinghousePayload: SupportCreateClearinghousePayload;
}

export interface DisableSupportClearinghouseRequest {
    id: string;
}

export interface DisableSupportClearinghouseEraRequest {
    id: string;
    force?: boolean;
}

export interface GetProviderClearinghouseRequest {
    id: string;
}

export interface GetProviderClearinghouseEraRequest {
    id: string;
}

export interface GetProviderClearinghouseEraItemRequest {
    id: string;
}

export interface GetSupportClearinghouseRequest {
    id: string;
}

export interface GetSupportClearinghouseEraRequest {
    id: string;
}

export interface GetSupportClearinghouseEraItemRequest {
    id: string;
}

export interface ListProviderClearinghouseEraItemsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderClearinghouseEraItemsOrderEnum>;
    filterCreated?: Array<string>;
    filterClearinghouseEraId?: Array<string>;
    filterNpi?: Array<string>;
    filterPcn?: Array<string>;
    filterFromDos?: Array<string>;
    filterIcn?: Array<string>;
    filterPatientFirstName?: Array<string>;
    filterPatientLastName?: Array<string>;
    filterSubscriberFirstName?: Array<string>;
    filterSubscriberLastName?: Array<string>;
    filterClearinghouseId?: Array<string>;
    sort?: Array<ProviderClearinghouseEraItemSortType>;
}

export interface ListProviderClearinghouseErasRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderClearinghouseErasOrderEnum>;
    filterCreated?: Array<string>;
    filterNpi?: Array<string>;
    filterEraId?: Array<string>;
    filterPayerId?: Array<string>;
    filterPaidDate?: Array<string>;
    filterProviderName?: Array<string>;
    filterPaymentType?: Array<string>;
    filterPayerName?: Array<string>;
    filterEin?: Array<string>;
    filterPayerPaid?: Array<string>;
    filterControlNumber?: Array<string>;
    filterClearinghouseId?: Array<string>;
    filterPlaidItemTransactionId?: Array<string>;
    sort?: Array<ProviderClearinghouseEraSortType>;
}

export interface ListProviderClearinghousesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderClearinghousesOrderEnum>;
    filterCreated?: Array<string>;
    filterName?: Array<string>;
    filterType?: Array<string>;
    sort?: Array<ProviderClearinghouseSortType>;
}

export interface ListSupportClearinghouseEraItemsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportClearinghouseEraItemsOrderEnum>;
    filterCreated?: Array<string>;
    filterTag?: Array<string>;
    filterClearinghouseEraId?: Array<string>;
    filterNpi?: Array<string>;
    filterPcn?: Array<string>;
    filterFromDos?: Array<string>;
    filterIcn?: Array<string>;
    filterPatientFirstName?: Array<string>;
    filterPatientLastName?: Array<string>;
    filterSubscriberFirstName?: Array<string>;
    filterSubscriberLastName?: Array<string>;
    filterPaymentId?: Array<string>;
    filterClearinghouseId?: Array<string>;
    sort?: Array<SupportClearinghouseEraItemSortType>;
}

export interface ListSupportClearinghouseErasRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportClearinghouseErasOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterNpi?: Array<string>;
    filterEraId?: Array<string>;
    filterPayerId?: Array<string>;
    filterPaidDate?: Array<string>;
    filterProviderName?: Array<string>;
    filterPaymentType?: Array<string>;
    filterPayerName?: Array<string>;
    filterEin?: Array<string>;
    filterPayerPaid?: Array<string>;
    filterControlNumber?: Array<string>;
    filterClearinghouseId?: Array<string>;
    filterPlaidItemTransactionId?: Array<string>;
    sort?: Array<SupportClearinghouseEraSortType>;
}

export interface ListSupportClearinghousesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportClearinghousesOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterName?: Array<string>;
    filterExternalId?: Array<string>;
    filterKey?: Array<string>;
    filterSecret?: Array<string>;
    filterType?: Array<string>;
    sort?: Array<SupportClearinghouseSortType>;
}

export interface PostProviderX12835EraRequest {
    id: string;
    body: string;
}

export interface PostX12835EraRequest {
    id: string;
    body: string;
}

export interface UpdateProviderClearinghouseEraRequest {
    id: string;
    providerUpdateClearinghouseEraPayload: ProviderUpdateClearinghouseEraPayload;
}

export interface UpdateSupportClearinghouseRequest {
    id: string;
    supportUpdateClearinghousePayload: SupportUpdateClearinghousePayload;
}

export interface UpdateSupportClearinghouseEraRequest {
    id: string;
    supportUpdateClearinghouseEraPayload: SupportUpdateClearinghouseEraPayload;
}

/**
 * no description
 */
export class ClearinghouseApi extends runtime.BaseAPI {

    /**
     * Create a provider enrollment
     * Create a provider enrollment
     */
    async createClearinghouseProviderEnrollmentRaw(requestParameters: CreateClearinghouseProviderEnrollmentRequest): Promise<runtime.ApiResponse<TemporaryUrl>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling createClearinghouseProviderEnrollment.');
        }

        if (requestParameters['supportCreateClearinghouseProviderEnrollmentPayload'] === null || requestParameters['supportCreateClearinghouseProviderEnrollmentPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClearinghouseProviderEnrollmentPayload','Required parameter requestParameters.supportCreateClearinghouseProviderEnrollmentPayload was null or undefined when calling createClearinghouseProviderEnrollment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/{id}/provider_enrollment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClearinghouseProviderEnrollmentPayloadToJSON(requestParameters['supportCreateClearinghouseProviderEnrollmentPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TemporaryUrlFromJSON(jsonValue));
    }

    /**
     * Create a provider enrollment
     * Create a provider enrollment
     */
    async createClearinghouseProviderEnrollment(requestParameters: CreateClearinghouseProviderEnrollmentRequest): Promise<TemporaryUrl> {
        const response = await this.createClearinghouseProviderEnrollmentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a clearinghouse from an integrated type
     * Create a clearinghouse
     */
    async createSupportClearinghouseRaw(requestParameters: CreateSupportClearinghouseRequest): Promise<runtime.ApiResponse<SupportClearinghouse>> {
        if (requestParameters['supportCreateClearinghousePayload'] === null || requestParameters['supportCreateClearinghousePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateClearinghousePayload','Required parameter requestParameters.supportCreateClearinghousePayload was null or undefined when calling createSupportClearinghouse.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateClearinghousePayloadToJSON(requestParameters['supportCreateClearinghousePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClearinghouseFromJSON(jsonValue));
    }

    /**
     * Creates a clearinghouse from an integrated type
     * Create a clearinghouse
     */
    async createSupportClearinghouse(requestParameters: CreateSupportClearinghouseRequest): Promise<SupportClearinghouse> {
        const response = await this.createSupportClearinghouseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a clearinghouse
     * Disable a clearinghouse
     */
    async disableSupportClearinghouseRaw(requestParameters: DisableSupportClearinghouseRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportClearinghouse.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a clearinghouse
     * Disable a clearinghouse
     */
    async disableSupportClearinghouse(requestParameters: DisableSupportClearinghouseRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportClearinghouseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disables a clearinghouse ERA and all associated payments. Unless force is true, a clearinghouse ERA can only be disabled when a newer active ERA exists with the same payment method type, payment number, paid amount, paid date, and payer name. Account ownership and authorization checks always apply.
     * Disable a clearinghouse ERA
     */
    async disableSupportClearinghouseEraRaw(requestParameters: DisableSupportClearinghouseEraRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportClearinghouseEra.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/era/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disables a clearinghouse ERA and all associated payments. Unless force is true, a clearinghouse ERA can only be disabled when a newer active ERA exists with the same payment method type, payment number, paid amount, paid date, and payer name. Account ownership and authorization checks always apply.
     * Disable a clearinghouse ERA
     */
    async disableSupportClearinghouseEra(requestParameters: DisableSupportClearinghouseEraRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportClearinghouseEraRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a clearinghouse
     * Get a clearinghouse
     */
    async getProviderClearinghouseRaw(requestParameters: GetProviderClearinghouseRequest): Promise<runtime.ApiResponse<ProviderClearinghouse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClearinghouse.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghouse/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClearinghouseFromJSON(jsonValue));
    }

    /**
     * Gets a clearinghouse
     * Get a clearinghouse
     */
    async getProviderClearinghouse(requestParameters: GetProviderClearinghouseRequest): Promise<ProviderClearinghouse> {
        const response = await this.getProviderClearinghouseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a clearinghouse era
     * Get a clearinghouses era
     */
    async getProviderClearinghouseEraRaw(requestParameters: GetProviderClearinghouseEraRequest): Promise<runtime.ApiResponse<ProviderClearinghouseEra>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClearinghouseEra.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghouse/era/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClearinghouseEraFromJSON(jsonValue));
    }

    /**
     * Gets a clearinghouse era
     * Get a clearinghouses era
     */
    async getProviderClearinghouseEra(requestParameters: GetProviderClearinghouseEraRequest): Promise<ProviderClearinghouseEra> {
        const response = await this.getProviderClearinghouseEraRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a claim remittance from an active ERA belonging to the current account.
     * Get a clearinghouses era item
     */
    async getProviderClearinghouseEraItemRaw(requestParameters: GetProviderClearinghouseEraItemRequest): Promise<runtime.ApiResponse<ProviderClearinghouseEraItem>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderClearinghouseEraItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghouse/era/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderClearinghouseEraItemFromJSON(jsonValue));
    }

    /**
     * Gets a claim remittance from an active ERA belonging to the current account.
     * Get a clearinghouses era item
     */
    async getProviderClearinghouseEraItem(requestParameters: GetProviderClearinghouseEraItemRequest): Promise<ProviderClearinghouseEraItem> {
        const response = await this.getProviderClearinghouseEraItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a clearinghouse
     * Get a clearinghouses
     */
    async getSupportClearinghouseRaw(requestParameters: GetSupportClearinghouseRequest): Promise<runtime.ApiResponse<SupportClearinghouse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClearinghouse.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClearinghouseFromJSON(jsonValue));
    }

    /**
     * Gets a clearinghouse
     * Get a clearinghouses
     */
    async getSupportClearinghouse(requestParameters: GetSupportClearinghouseRequest): Promise<SupportClearinghouse> {
        const response = await this.getSupportClearinghouseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a clearinghouse era
     * Get a clearinghouses era
     */
    async getSupportClearinghouseEraRaw(requestParameters: GetSupportClearinghouseEraRequest): Promise<runtime.ApiResponse<SupportClearinghouseEra>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClearinghouseEra.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/era/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClearinghouseEraFromJSON(jsonValue));
    }

    /**
     * Gets a clearinghouse era
     * Get a clearinghouses era
     */
    async getSupportClearinghouseEra(requestParameters: GetSupportClearinghouseEraRequest): Promise<SupportClearinghouseEra> {
        const response = await this.getSupportClearinghouseEraRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a clearinghouse era item
     * Get a clearinghouses era item
     */
    async getSupportClearinghouseEraItemRaw(requestParameters: GetSupportClearinghouseEraItemRequest): Promise<runtime.ApiResponse<SupportClearinghouseEraItem>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportClearinghouseEraItem.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/era/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportClearinghouseEraItemFromJSON(jsonValue));
    }

    /**
     * Gets a clearinghouse era item
     * Get a clearinghouses era item
     */
    async getSupportClearinghouseEraItem(requestParameters: GetSupportClearinghouseEraItemRequest): Promise<SupportClearinghouseEraItem> {
        const response = await this.getSupportClearinghouseEraItemRaw(requestParameters);
        return await response.value();
    }

    /**
     * Lists claim remittances from active ERAs belonging to the current account, including items with no posted payments. Use filterClearinghouseEraId to retrieve items for an ERA.
     * Get a list of clearinghouse era items
     */
    async listProviderClearinghouseEraItemsRaw(requestParameters: ListProviderClearinghouseEraItemsRequest): Promise<runtime.ApiResponse<Array<ProviderClearinghouseEraItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClearinghouseEraId) {
            queryParameters['filterClearinghouseEraId'] = requestParameters.filterClearinghouseEraId;
        }

        if (requestParameters.filterNpi) {
            queryParameters['filterNpi'] = requestParameters.filterNpi;
        }

        if (requestParameters.filterPcn) {
            queryParameters['filterPcn'] = requestParameters.filterPcn;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterIcn) {
            queryParameters['filterIcn'] = requestParameters.filterIcn;
        }

        if (requestParameters.filterPatientFirstName) {
            queryParameters['filterPatientFirstName'] = requestParameters.filterPatientFirstName;
        }

        if (requestParameters.filterPatientLastName) {
            queryParameters['filterPatientLastName'] = requestParameters.filterPatientLastName;
        }

        if (requestParameters.filterSubscriberFirstName) {
            queryParameters['filterSubscriberFirstName'] = requestParameters.filterSubscriberFirstName;
        }

        if (requestParameters.filterSubscriberLastName) {
            queryParameters['filterSubscriberLastName'] = requestParameters.filterSubscriberLastName;
        }

        if (requestParameters.filterClearinghouseId) {
            queryParameters['filterClearinghouseId'] = requestParameters.filterClearinghouseId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghouse/era/item`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClearinghouseEraItemFromJSON));
    }

    /**
     * Lists claim remittances from active ERAs belonging to the current account, including items with no posted payments. Use filterClearinghouseEraId to retrieve items for an ERA.
     * Get a list of clearinghouse era items
     */
    async listProviderClearinghouseEraItems(requestParameters: ListProviderClearinghouseEraItemsRequest): Promise<Array<ProviderClearinghouseEraItem>> {
        const response = await this.listProviderClearinghouseEraItemsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of clearinghouse era
     * Get a list of clearinghouse era
     */
    async listProviderClearinghouseErasRaw(requestParameters: ListProviderClearinghouseErasRequest): Promise<runtime.ApiResponse<Array<ProviderClearinghouseEra>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterNpi) {
            queryParameters['filterNpi'] = requestParameters.filterNpi;
        }

        if (requestParameters.filterEraId) {
            queryParameters['filterEraId'] = requestParameters.filterEraId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterPaidDate) {
            queryParameters['filterPaidDate'] = requestParameters.filterPaidDate;
        }

        if (requestParameters.filterProviderName) {
            queryParameters['filterProviderName'] = requestParameters.filterProviderName;
        }

        if (requestParameters.filterPaymentType) {
            queryParameters['filterPaymentType'] = requestParameters.filterPaymentType;
        }

        if (requestParameters.filterPayerName) {
            queryParameters['filterPayerName'] = requestParameters.filterPayerName;
        }

        if (requestParameters.filterEin) {
            queryParameters['filterEin'] = requestParameters.filterEin;
        }

        if (requestParameters.filterPayerPaid) {
            queryParameters['filterPayerPaid'] = requestParameters.filterPayerPaid;
        }

        if (requestParameters.filterControlNumber) {
            queryParameters['filterControlNumber'] = requestParameters.filterControlNumber;
        }

        if (requestParameters.filterClearinghouseId) {
            queryParameters['filterClearinghouseId'] = requestParameters.filterClearinghouseId;
        }

        if (requestParameters.filterPlaidItemTransactionId) {
            queryParameters['filterPlaidItemTransactionId'] = requestParameters.filterPlaidItemTransactionId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghouse/era`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClearinghouseEraFromJSON));
    }

    /**
     * Gets a list of clearinghouse era
     * Get a list of clearinghouse era
     */
    async listProviderClearinghouseEras(requestParameters: ListProviderClearinghouseErasRequest): Promise<Array<ProviderClearinghouseEra>> {
        const response = await this.listProviderClearinghouseErasRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of clearinghouses
     * Get a list of clearinghouses
     */
    async listProviderClearinghousesRaw(requestParameters: ListProviderClearinghousesRequest): Promise<runtime.ApiResponse<Array<ProviderClearinghouse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterType) {
            queryParameters['filterType'] = requestParameters.filterType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghouse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClearinghouseFromJSON));
    }

    /**
     * Gets a list of clearinghouses
     * Get a list of clearinghouses
     */
    async listProviderClearinghouses(requestParameters: ListProviderClearinghousesRequest): Promise<Array<ProviderClearinghouse>> {
        const response = await this.listProviderClearinghousesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of clearinghouse era items
     * Get a list of clearinghouse era items
     */
    async listSupportClearinghouseEraItemsRaw(requestParameters: ListSupportClearinghouseEraItemsRequest): Promise<runtime.ApiResponse<Array<SupportClearinghouseEraItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterClearinghouseEraId) {
            queryParameters['filterClearinghouseEraId'] = requestParameters.filterClearinghouseEraId;
        }

        if (requestParameters.filterNpi) {
            queryParameters['filterNpi'] = requestParameters.filterNpi;
        }

        if (requestParameters.filterPcn) {
            queryParameters['filterPcn'] = requestParameters.filterPcn;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterIcn) {
            queryParameters['filterIcn'] = requestParameters.filterIcn;
        }

        if (requestParameters.filterPatientFirstName) {
            queryParameters['filterPatientFirstName'] = requestParameters.filterPatientFirstName;
        }

        if (requestParameters.filterPatientLastName) {
            queryParameters['filterPatientLastName'] = requestParameters.filterPatientLastName;
        }

        if (requestParameters.filterSubscriberFirstName) {
            queryParameters['filterSubscriberFirstName'] = requestParameters.filterSubscriberFirstName;
        }

        if (requestParameters.filterSubscriberLastName) {
            queryParameters['filterSubscriberLastName'] = requestParameters.filterSubscriberLastName;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterClearinghouseId) {
            queryParameters['filterClearinghouseId'] = requestParameters.filterClearinghouseId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/era/item`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClearinghouseEraItemFromJSON));
    }

    /**
     * Gets a list of clearinghouse era items
     * Get a list of clearinghouse era items
     */
    async listSupportClearinghouseEraItems(requestParameters: ListSupportClearinghouseEraItemsRequest): Promise<Array<SupportClearinghouseEraItem>> {
        const response = await this.listSupportClearinghouseEraItemsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of clearinghouse era
     * Get a list of clearinghouse era
     */
    async listSupportClearinghouseErasRaw(requestParameters: ListSupportClearinghouseErasRequest): Promise<runtime.ApiResponse<Array<SupportClearinghouseEra>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterNpi) {
            queryParameters['filterNpi'] = requestParameters.filterNpi;
        }

        if (requestParameters.filterEraId) {
            queryParameters['filterEraId'] = requestParameters.filterEraId;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterPaidDate) {
            queryParameters['filterPaidDate'] = requestParameters.filterPaidDate;
        }

        if (requestParameters.filterProviderName) {
            queryParameters['filterProviderName'] = requestParameters.filterProviderName;
        }

        if (requestParameters.filterPaymentType) {
            queryParameters['filterPaymentType'] = requestParameters.filterPaymentType;
        }

        if (requestParameters.filterPayerName) {
            queryParameters['filterPayerName'] = requestParameters.filterPayerName;
        }

        if (requestParameters.filterEin) {
            queryParameters['filterEin'] = requestParameters.filterEin;
        }

        if (requestParameters.filterPayerPaid) {
            queryParameters['filterPayerPaid'] = requestParameters.filterPayerPaid;
        }

        if (requestParameters.filterControlNumber) {
            queryParameters['filterControlNumber'] = requestParameters.filterControlNumber;
        }

        if (requestParameters.filterClearinghouseId) {
            queryParameters['filterClearinghouseId'] = requestParameters.filterClearinghouseId;
        }

        if (requestParameters.filterPlaidItemTransactionId) {
            queryParameters['filterPlaidItemTransactionId'] = requestParameters.filterPlaidItemTransactionId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/era`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClearinghouseEraFromJSON));
    }

    /**
     * Gets a list of clearinghouse era
     * Get a list of clearinghouse era
     */
    async listSupportClearinghouseEras(requestParameters: ListSupportClearinghouseErasRequest): Promise<Array<SupportClearinghouseEra>> {
        const response = await this.listSupportClearinghouseErasRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of clearinghouses
     * Get a list of clearinghouses
     */
    async listSupportClearinghousesRaw(requestParameters: ListSupportClearinghousesRequest): Promise<runtime.ApiResponse<Array<SupportClearinghouse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterKey) {
            queryParameters['filterKey'] = requestParameters.filterKey;
        }

        if (requestParameters.filterSecret) {
            queryParameters['filterSecret'] = requestParameters.filterSecret;
        }

        if (requestParameters.filterType) {
            queryParameters['filterType'] = requestParameters.filterType;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClearinghouseFromJSON));
    }

    /**
     * Gets a list of clearinghouses
     * Get a list of clearinghouses
     */
    async listSupportClearinghouses(requestParameters: ListSupportClearinghousesRequest): Promise<Array<SupportClearinghouse>> {
        const response = await this.listSupportClearinghousesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an ERA from an x12 835 document
     * Create an ERA from an x12 835 document
     */
    async postProviderX12835EraRaw(requestParameters: PostProviderX12835EraRequest): Promise<runtime.ApiResponse<ObjectIdResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postProviderX12835Era.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postProviderX12835Era.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/edi-x12';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:clearinghouse"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghouse/{id}/era/x12/5010/835`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectIdResponseFromJSON(jsonValue));
    }

    /**
     * Create an ERA from an x12 835 document
     * Create an ERA from an x12 835 document
     */
    async postProviderX12835Era(requestParameters: PostProviderX12835EraRequest): Promise<ObjectIdResponse> {
        const response = await this.postProviderX12835EraRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an ERA from an x12 835 document
     * Create an ERA from an x12 835 document
     */
    async postX12835EraRaw(requestParameters: PostX12835EraRequest): Promise<runtime.ApiResponse<ObjectIdResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postX12835Era.');
        }

        if (requestParameters['body'] === null || requestParameters['body'] === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postX12835Era.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/edi-x12';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/{id}/era/x12/5010/835`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectIdResponseFromJSON(jsonValue));
    }

    /**
     * Create an ERA from an x12 835 document
     * Create an ERA from an x12 835 document
     */
    async postX12835Era(requestParameters: PostX12835EraRequest): Promise<ObjectIdResponse> {
        const response = await this.postX12835EraRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update the bank deposit linked to a clearinghouse ERA. Send a null plaidItemTransactionId to remove a manual posting. Automatic postings cannot be unlinked.
     * Update a clearinghouse era
     */
    async updateProviderClearinghouseEraRaw(requestParameters: UpdateProviderClearinghouseEraRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProviderClearinghouseEra.');
        }

        if (requestParameters['providerUpdateClearinghouseEraPayload'] === null || requestParameters['providerUpdateClearinghouseEraPayload'] === undefined) {
            throw new runtime.RequiredError('providerUpdateClearinghouseEraPayload','Required parameter requestParameters.providerUpdateClearinghouseEraPayload was null or undefined when calling updateProviderClearinghouseEra.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:clearinghouse"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/clearinghouse/era/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderUpdateClearinghouseEraPayloadToJSON(requestParameters['providerUpdateClearinghouseEraPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update the bank deposit linked to a clearinghouse ERA. Send a null plaidItemTransactionId to remove a manual posting. Automatic postings cannot be unlinked.
     * Update a clearinghouse era
     */
    async updateProviderClearinghouseEra(requestParameters: UpdateProviderClearinghouseEraRequest): Promise<ObjectNoResponse> {
        const response = await this.updateProviderClearinghouseEraRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a clearinghouse
     * Update a clearinghouse
     */
    async updateSupportClearinghouseRaw(requestParameters: UpdateSupportClearinghouseRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportClearinghouse.');
        }

        if (requestParameters['supportUpdateClearinghousePayload'] === null || requestParameters['supportUpdateClearinghousePayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateClearinghousePayload','Required parameter requestParameters.supportUpdateClearinghousePayload was null or undefined when calling updateSupportClearinghouse.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateClearinghousePayloadToJSON(requestParameters['supportUpdateClearinghousePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a clearinghouse
     * Update a clearinghouse
     */
    async updateSupportClearinghouse(requestParameters: UpdateSupportClearinghouseRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportClearinghouseRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update the bank deposit linked to a clearinghouse ERA. Send a null plaidItemTransactionId to remove a manual posting. Automatic postings cannot be unlinked.
     * Update a clearinghouse era
     */
    async updateSupportClearinghouseEraRaw(requestParameters: UpdateSupportClearinghouseEraRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportClearinghouseEra.');
        }

        if (requestParameters['supportUpdateClearinghouseEraPayload'] === null || requestParameters['supportUpdateClearinghouseEraPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateClearinghouseEraPayload','Required parameter requestParameters.supportUpdateClearinghouseEraPayload was null or undefined when calling updateSupportClearinghouseEra.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:clearinghouse", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/clearinghouse/era/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateClearinghouseEraPayloadToJSON(requestParameters['supportUpdateClearinghouseEraPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update the bank deposit linked to a clearinghouse ERA. Send a null plaidItemTransactionId to remove a manual posting. Automatic postings cannot be unlinked.
     * Update a clearinghouse era
     */
    async updateSupportClearinghouseEra(requestParameters: UpdateSupportClearinghouseEraRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportClearinghouseEraRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderClearinghouseEraItemsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderClearinghouseErasOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListProviderClearinghousesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClearinghouseEraItemsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClearinghouseErasOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportClearinghousesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
